import React, { useEffect, useState } from "react";
import * as RB from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import * as utils from "../../Utils/comman";
import MultiFileUpload from "./MultiFileUpload";
import { useSelector } from "react-redux";
import { DocumentText1 } from "iconsax-react";
import DatePicker from "react-datepicker";
import moment from "moment/moment";
import QuotationFile from "./QuotationFile";

function Add(props) {
  const [formData, setFormData] = useState({
    meeting_date: null,
    meetingName: "",
    subject: "",
    counter: "",
    counterName: "",
    city: "",
    budget: "",
    notes: "",
  });
  const [validated, setValidated] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState();
  const [meeting, setMeeting] = useState([]);
  const [counter, setCounter] = useState([]);
  const [rmNote, setRmNote] = useState("");
  const [fileUpload, setFileUpload] = useState("");
  const [fileUploads, setFileUploads] = useState({
    meetingPhotos: [],
    artisanData: [],
    meetingExpenses: [],
    expenseBills: [],
  });
  const [brandFinalNote, setBrandFinalNote] = useState("");

  const [EditfileUploads, setEditFileUploads] = useState({
    meetingPhotos: [],
    artisanData: [],
    meetingExpenses: [],
    expenseBills: [],
  });
  const [brandNote, setBrandNote] = useState("");
  const [brandAmt, setBrandAmt] = useState("");
  const [isDisable, setisDisable] = useState(false);
  const [isReporting, setIsReporting] = useState(false);
  const [currentStatus, setCurrentStatus] = useState("1");
  const [isBrandReject, setIsBrandReject] = useState(false);
  const [quotation, setQuotation] = useState([]);
  const [editQuotation, setEditQuotation] = useState([]);

  const userProfile = useSelector((state) => state.userProfile.userProfile);
  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions,
  );
  const location = useLocation();

  const handleBackClick = () => {
    const propdata = {
      mode: "list",
    };
    props.onChange(propdata);
  };

  useEffect(() => {
    getMeeting();
    getCounter();
  }, []);

  const getMeeting = () => {
    utils
      .callAPI("get", `/meeting/subject/list?page=${0}&per_page=${0} `)
      .then((res) => {
        if (typeof res !== "undefined") {
          // setMeeting(res);
          const activeSub = res.result.filter((m) => m.isActive === "1");
          // console.log(activeSub);
          setMeeting(activeSub);
        } else {
          setMeeting([]);
        }
      })
      .catch((err) => {
        setMeeting([]);
      });
  };

  // const getCounter = () => {
  //   utils
  //     .callAPI("post", `/sales/getsalesFormbyid`)
  //     .then((res) => {
  //       if (typeof res !== "undefined") {
  //         setCounter(res);
  //       } else {
  //         setCounter([]);
  //       }
  //     })
  //     .catch((err) => {
  //       setCounter([]);
  //     });
  // };
  const vendorTypes = [
    "Dealer",
    "Distributor",
    "Retailer",
    "Key Accounts",
    "PRO",
  ];
  const getCounter = async () => {
    const userId = userProfile?.employeeId;
    let allData = [];

    for (const type of vendorTypes) {
      const formData = new FormData();
      formData.append("vendor_type", type);
      formData.append("id", "");
      formData.append("userId", userId);

      try {
        const res = await utils.callAPI(
          "post",
          `/sales/getsalesFormbyid`,
          formData,
        );
        if (res && Array.isArray(res?.result)) {
          console.log(res);
          allData = [...allData, ...res.result];
        }
      } catch (err) {
        console.error(`Error fetching for ${type}:`, err);
      }
    }

    setCounter(allData); // Final merged result
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "counter") {
      const selectedCounter = counter.find((item) => item.id === value);
      if (selectedCounter) {
        setFormData((prevState) => ({
          ...prevState,
          [name]: value,
          city: selectedCounter.company_city,
        }));
      }
    } else {
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
    } else {
      if (
        props?.rowData &&
        (props.rowData.status === "5" || props.rowData.status === "9")
      ) {
        setCurrentStatus("7");
      } else {
        setCurrentStatus("1");
      }
      setIsSubmit(true);
    }
  };

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  useEffect(() => {
    if (isSubmit) {
      const createFormData = async () => {
        const bodyFormData = new FormData();

        // Add other fields to FormData
        if (isEdit) {
          bodyFormData.append("id", props?.rowData?.id);
        }
        bodyFormData.append("emp_id", userProfile?.employeeId);
        bodyFormData.append(
          "meeting_date",
          moment(formData.meeting_date).format("YYYY-MM-DD"),
        );
        // bodyFormData.append("name", formData.meetingName);
        bodyFormData.append("subject", formData.subject);
        bodyFormData.append("counter", formData.counter);
        bodyFormData.append("city", formData.city);
        bodyFormData.append("budget", formData.budget);
        bodyFormData.append("counter_name", formData.counterName);
        bodyFormData.append("emp_notes", formData.notes);
        bodyFormData.append("reporting_id", "");
        bodyFormData.append("reporting_notes", "");
        bodyFormData.append("brand_id", "");
        bodyFormData.append("brand_amt", "");
        bodyFormData.append("brand_notes", "");
        bodyFormData.append("brand_advance_credit_amt", "");
        bodyFormData.append("receive_notes", "");
        bodyFormData.append("updated_by", "emp");
        bodyFormData.append("status", currentStatus);
        bodyFormData.append("brand_final_notes", "");
        bodyFormData.append("brand_final_amt_attachment", "");
        bodyFormData.append("brand_final_amt", "");
        bodyFormData.append("sales_id", "");
        bodyFormData.append("emp_final_note", "");
        bodyFormData.append("current_action", "Add");

        bodyFormData.append("emp_meeting_files", JSON.stringify([]));
        // 👉 Convert quotation files to base64 and build payload
        let quotationFinalData = [];

        const activeQuotationFiles = quotation.filter((q) => !q.isDeleted);

        if (activeQuotationFiles.length > 0) {
          const base64Files = await Promise.all(
            activeQuotationFiles.map(async (item) => {
              const base64 = await convertToBase64(item.file);
              return {
                file: base64, // 🔑 SAME KEY backend expects
              };
            }),
          );

          quotationFinalData = [
            {
              file_name: "Quotation File",
              meeting_image: base64Files,
            },
          ];
        }
        bodyFormData.append(
          "emp_meeting_quatation_files",
          JSON.stringify(quotationFinalData),
        );

        utils
          .callAPI("post", `/meeting/save`, bodyFormData)
          .then((res) => {
            if (typeof res !== "undefined") {
              setIsSubmit(false);
              const propdata = {
                mode: "list",
              };
              props.onChange(propdata);
            }
            setIsSubmit(false);
          })
          .catch((err) => {
            setIsSubmit(false);
          });
      };

      createFormData();
    }
  }, [isSubmit]);

  useEffect(() => {
    if (props.rowData && Object.keys(props.rowData).length > 0) {
      console.log(props?.rowData);
      setIsEdit(true);
      setFormData({
        ...formData,
        meeting_date: props?.rowData?.meeting_date,
        meetingName: props?.rowData?.name,
        subject: props?.rowData?.subject,
        counter: props?.rowData?.counter,
        counterName: props?.rowData?.counter_name,
        city: props?.rowData?.city,
        budget: props?.rowData?.budget,
        notes: props?.rowData?.emp_notes,
      });
      setEditQuotation(props?.rowData?.quotation);

      if (
        props?.rowData?.status == "1" &&
        location.pathname == "/marketing/team-meeting-request"
      ) {
        setisDisable(true);
        setIsReporting(true);
      }
      if (props?.rowData?.status == "5") {
        setRmNote(props?.rowData?.reporting_notes);
        setBrandNote(props?.rowData?.brand_notes);
        setBrandAmt(props?.rowData?.brand_amt);
        setisDisable(true);
      }
      if (props?.rowData?.status == "9") {
        setRmNote(props?.rowData?.reporting_notes);
        setBrandNote(props?.rowData?.brand_notes);
        setBrandAmt(props?.rowData?.brand_amt);
        setBrandFinalNote(props?.rowData?.brand_final_notes);
        setIsBrandReject(true);
        setisDisable(true);
      }
      const categorizedFiles = props?.rowData?.document.reduce(
        (acc, doc) => {
          if (doc.file_name.includes("Meeting Photos")) {
            acc.meetingPhotos.push({
              id: doc.id,
              attachPath: doc.attachPath,
              filename: doc.meeting_image,
            });
          } else if (doc.file_name.includes("Artisan Data")) {
            acc.artisanData.push({
              id: doc.id,
              attachPath: doc.attachPath,
              filename: doc.meeting_image,
            });
          } else if (doc.file_name.includes("Meeting Expenses")) {
            acc.meetingExpenses.push({
              id: doc.id,
              attachPath: doc.attachPath,
              filename: doc.meeting_image,
            });
          } else if (doc.file_name.includes("Expenses Bill")) {
            acc.expenseBills.push({
              id: doc.id,
              attachPath: doc.attachPath,
              filename: doc.meeting_image,
            });
          }
          return acc;
        },
        {
          meetingPhotos: [],
          artisanData: [],
          meetingExpenses: [],
          expenseBills: [],
        },
      );

      setEditFileUploads(categorizedFiles);
    } else {
      setIsEdit(false);
    }
  }, [props.rowData]);

  const handleApprove = () => {
    setCurrentStatus("2");
    setIsSubmit(true);
  };
  const handleReject = () => {
    setCurrentStatus("3");
    setIsSubmit(true);
  };
  return (
    <div className="section-body">
      <RB.Card>
        <RB.Card.Header>
          <h4>Add Meeting</h4>
          <div className="card-header-action">
            <Link className="btn btn-underline me-2" onClick={handleBackClick}>
              Back
            </Link>
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          <RB.Form noValidate validated={validated} onSubmit={handleSubmit}>
            <RB.Row>
              <RB.Col md={6}>
                <div className="mt-3">
                  <RB.FloatingLabel className="floating-label-fancy">
                    <DatePicker
                      selected={formData.meeting_date}
                      onChange={(date) =>
                        setFormData({ ...formData, meeting_date: date })
                      }
                      dateFormat="dd-MM-yyyy"
                      className="form-control"
                      placeholderText="Select Meeting Date"
                      minDate={new Date()}
                      required
                      disabled={isDisable}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
              {/* <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="name"
                    label="Meeting Name"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Meeting Name"
                      name="meetingName"
                      value={formData.meetingName}
                      onChange={handleInputChange}
                      required
                      disabled={isDisable}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col> */}

              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="subject"
                    label="Type of Meeting"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Select
                      value={formData.subject}
                      onChange={handleInputChange}
                      required
                      disabled={isDisable}
                      name="subject"
                    >
                      <option value="">Type of Meeting</option>
                      {meeting?.map((m) => (
                        <option key={m.id} value={m.id}>
                          {m.subject_name}
                        </option>
                      ))}
                    </RB.Form.Select>
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="counter"
                    disabled={isDisable}
                    label="Select Counter"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Select
                      value={formData.counter}
                      onChange={handleInputChange}
                      disabled={isDisable}
                      required
                      name="counter"
                    >
                      <option value="">Select Counter</option>
                      {Array.isArray(counter) &&
                        counter?.map((m) => (
                          <option key={m.id} value={m.id}>
                            {`${m.companyName} (${m.vendor_type})`}
                          </option>
                        ))}
                    </RB.Form.Select>
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="counterName"
                    label="Retail Counter/ Architect/ Contractor Name"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      disabled={isDisable}
                      type="text"
                      placeholder="Enter Counter Name"
                      name="counterName"
                      value={formData.counterName}
                      onChange={handleInputChange}
                      onKeyPress={(e) => {
                        if (!/^[a-zA-Z\s]*$/.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      required
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="city"
                    label="City"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      disabled={isDisable}
                      placeholder="Enter City"
                      name="city"
                      value={formData.city}
                      onChange={handleInputChange}
                      required
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="budget"
                    label="Budget"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      disabled={isDisable}
                      placeholder="Enter Budget"
                      name="budget"
                      value={formData.budget}
                      onChange={handleInputChange}
                      required
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
              <QuotationFile
                quotation={quotation}
                setQuotation={setQuotation}
                setEditQuotation={setEditQuotation}
                editQuotation={editQuotation}
              />
              <RB.Col md={12}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="notes"
                    label="Notes"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      as="textarea"
                      rows={3}
                      disabled={isDisable}
                      placeholder="Enter Notes"
                      name="notes"
                      value={formData.notes}
                      onChange={handleInputChange}
                      required
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
              {(isReporting || isBrandReject) && (
                <>
                  <RB.Col md={12}>
                    <div className="mb-3">
                      <RB.FloatingLabel
                        controlId="notes"
                        label="Notes"
                        className="floating-label-fancy"
                      >
                        <RB.Form.Control
                          as="textarea"
                          rows={3}
                          placeholder="Enter Notes"
                          name="notes"
                          value={rmNote}
                          onChange={(e) => setRmNote(e.target.value)}
                          // required
                          disabled={isBrandReject}
                        />
                      </RB.FloatingLabel>
                    </div>
                  </RB.Col>

                  {!isBrandReject && (
                    <RB.Row className="justify-content-end mt-3">
                      <RB.Col className="col-auto">
                        <RB.Button
                          variant="success"
                          className="me-1"
                          onClick={handleApprove}
                        >
                          Approve
                        </RB.Button>
                        <RB.Button variant="danger" onClick={handleReject}>
                          Reject
                        </RB.Button>
                      </RB.Col>
                    </RB.Row>
                  )}
                </>
              )}
              {(props?.rowData?.status == "5" || isBrandReject) && (
                <>
                  <RB.Col md={7}>
                    <div className="mb-3">
                      <label className="form-label">
                        Advance Credited Amount
                      </label>
                      <div className="d-flex align-items-center">
                        <RB.Form.Control
                          type="file"
                          name="quotation"
                          // onChange={handleFileUpload}
                          // accept=".jpg,.jpeg,.png"
                          className="me-2 flex-grow-1"
                          disabled={isDisable}
                          // required
                        />
                        {isEdit &&
                          /\.(jpg|jpeg|png|pdf|doc|docx|xls|xlsx)$/i.test(
                            props.rowData.brandattachPath,
                          ) && (
                            <a
                              href={props.rowData.brandattachPath}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="btn btn-link p-0"
                              title="View Current AttechMent"
                            >
                              <DocumentText1 />
                            </a>
                          )}
                      </div>
                    </div>
                  </RB.Col>
                  <RB.Col md={5}>
                    <div className="mt-2">
                      <RB.FloatingLabel
                        controlId="notes"
                        label="Amountss"
                        className="floating-label-fancy"
                      >
                        <RB.Form.Control
                          type="text"
                          placeholder="Enter Amount"
                          // name="notes"
                          value={brandAmt}
                          disabled={isDisable}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d*\.?\d*$/.test(value)) {
                              setBrandAmt(value);
                            }
                          }}
                          required
                        />
                      </RB.FloatingLabel>
                    </div>
                  </RB.Col>
                  <RB.Col md={12}>
                    <div className="mb-3">
                      <RB.FloatingLabel
                        controlId="notes"
                        label="Brand Manager Notes"
                        className="floating-label-fancy"
                      >
                        <RB.Form.Control
                          as="textarea"
                          rows={3}
                          placeholder="Enter Notes"
                          name="notes"
                          disabled={isDisable}
                          value={brandNote}
                          onChange={(e) => setBrandNote(e.target.value)}
                          // required
                        />
                      </RB.FloatingLabel>
                    </div>
                  </RB.Col>
                </>
              )}
              {(props?.rowData?.status == "5" || isBrandReject) && (
                <RB.Col md={12}>
                  <MultiFileUpload
                    fileUploads={fileUploads}
                    setFileUploads={setFileUploads}
                    EditfileUploads={EditfileUploads}
                    setEditFileUploads={setEditFileUploads}
                  />
                </RB.Col>
              )}
            </RB.Row>

            {isBrandReject && (
              <RB.Col md={12}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="notes"
                    label="Brand Manager Final Notes"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      as="textarea"
                      rows={3}
                      placeholder="Enter Notes"
                      name="notes"
                      value={brandFinalNote}
                      disabled={isBrandReject}
                      // required
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
            )}
            {!isReporting && (
              <RB.Row className="justify-content-end mt-3">
                <RB.Col className="col-auto">
                  <RB.Button variant="primary" type="submit">
                    Submit
                  </RB.Button>
                </RB.Col>
              </RB.Row>
            )}
          </RB.Form>
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default Add;
